import _toLower from "lodash-es/toLower";
import _isEqual from "lodash-es/isEqual";
import _isString from "lodash-es/isString";
import _negate from "lodash-es/negate";
import _map from "lodash-es/map";
import _isNil from "lodash-es/isNil";
import _flowRight from "lodash-es/flowRight";
import _curryRight from "lodash-es/curryRight";
import _cond from "lodash-es/cond";
import fetch from 'node-fetch';
export const otherwise = () => true;
export const isDefined = _negate(_isNil);
export const delay = ms => new Promise(res => setTimeout(res, ms));
export const cMap = _curryRight(_map);

function bisect(data, index) {
  const i = Math.min(data.length, index);
  return [data.slice(0, i), data.slice(i)];
}

const outputEmpty = () => Promise.resolve();

const asyncIfDefined = func => _cond([[_isNil, outputEmpty], [otherwise, func]]);
/* order is not guaranteed in `results` array */


export async function asyncMap(data, callback, concurrent) {
  const [seed, rest] = bisect(data, concurrent);
  const results = [];

  const next = () => rest.pop();

  const evaluate = asyncIfDefined(el => callback(el).then(res => {
    results.push(res);
    return evaluate(next());
  }));
  await Promise.allSettled(seed.map(evaluate));
  return results;
}
export const nCompose = (funcs, data) => funcs.reverse().reduce((seed, func) => isDefined(seed) ? func(seed) : null, data);
/**
 * Applies @param func on @param a and @returns a without modification
 */

export const perform = _curryRight((a, func) => {
  func(a);
  return a;
});
/**
 * If a is not defined, fetch using fallback function
 */

export const asyncFallback = (a, fallback) => a ? Promise.resolve(a) : fallback();
export const transparent = a => a;
export const jFetch = (url, options) => fetch(url, options).then(res => {
  if (!res.ok) {
    throw new Error(`FETCH ERROR ${res.status} ${res.statusText}`);
  }

  return res;
}); // https://www.npmjs.com/package/rotate-array

/**
 * Rotates the array num places to the left, i.e. it shifts num items out of the array and pushes them back on the end. 
 * The reverse is done when num is negative. In addition, rotate automatically wraps rotations which are larger than array.length.

Examples:

var beatles = ['paul', 'john', 'ringo', 'george'];
rotate(beatles, 2);
console.log(beatles); // [ 'ringo', 'george', 'paul', 'john' ]
 */

export function rotate(array, num) {
  num = (num || 0) % array.length;

  if (num < 0) {
    num += array.length;
  }

  const removed = array.splice(0, num);
  array.push.apply(array, removed);
  return array;
}
export const isEqual = a => b => _isEqual(a, b);
export const ifThen = pred => then => c => pred(c) ? then(c) : '';
export const ifDefined = ifThen(_negate(_isNil));
export const ifString = ifThen(_isString);
export const noCaseEquals = a => _flowRight([isEqual(_toLower(a)), _toLower]);